// Rule being triggered because the parent folder is components, should be elements
// eslint-disable-next-line @billy/shine-accounting/consistent-alias-imports -- ../components is this step's own components folder, not src/components
import { AddressingLineFormat } from '../components/AddressingLineSelector/types/frAddressingLinesFormats'

export const computeFRAddressingLineFromCompanyIDs = ({
  siren,
  siret,
  addressingLineFormat = AddressingLineFormat.SIREN,
}: {
  siren?: string
  siret: string
  addressingLineFormat: AddressingLineFormat
}) => {
  if (!siren) {
    if (!siret) {
      return null
    }

    siren = siret.slice(0, 9)
  }

  if (addressingLineFormat === AddressingLineFormat.SIREN) {
    if (siren.length !== 9) {
      return null
    }

    return siren ?? null
  }

  if (addressingLineFormat === AddressingLineFormat.SIREN_SIRET) {
    if (siret.length !== 14) {
      return null
    }

    return `${siren}_${siret}`
  }

  return null
}
